<template>
    <div class="metrics-dashboard">
        <!-- Header opcional para contexto -->
        <div class="metrics-header" v-if="showHeader">
            <div class="metrics-title">
                <i class="fas fa-chart-bar mr-2"></i>
                Resumo da Frota
            </div>
            <div class="metrics-subtitle">
                Visão geral em tempo real dos veículos
            </div>
        </div>

        <!-- Grid de cards de métricas -->
        <div class="metrics-grid">
            <!-- Card No Pátio -->
            <div class="metric-card available-card" @click="$emit('card-clicked', 'patio')">
                <div class="metric-header">
                    <div class="metric-icon available-icon">
                        <i class="fas fa-parking"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">No Pátio</div>
                        <div class="metric-description">Veículos disponíveis</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.available || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status available-status">
                        <i class="fas fa-circle"></i>
                        Disponível
                    </span>
                </div>
            </div>

            <!-- Card Reservas do Dia -->
            <div class="metric-card today-card" @click="$emit('card-clicked', 'reserva_do_dia')">
                <div class="metric-header">
                    <div class="metric-icon today-icon">
                        <i class="fas fa-calendar-day"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">Reservas do Dia</div>
                        <div class="metric-description">Agendadas para hoje</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.reservationsToday || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status today-status">
                        <i class="fas fa-circle"></i>
                        Hoje
                    </span>
                </div>
            </div>

            <!-- Card Pendências -->
            <div class="metric-card pending-card" @click="$emit('card-clicked', 'pendencia')">
                <div class="metric-header">
                    <div class="metric-icon pending-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">Pendências</div>
                        <div class="metric-description">Requer atenção</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.pendencies || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status pending-status" v-if="values.pendencies > 0">
                        <i class="fas fa-exclamation-circle"></i>
                        Urgente
                    </span>
                    <span class="metric-status ok-status" v-else>
                        <i class="fas fa-check-circle"></i>
                        OK
                    </span>
                </div>
            </div>

            <!-- Card Retirados -->
            <div class="metric-card progress-card" @click="$emit('card-clicked', 'retirado')">
                <div class="metric-header">
                    <div class="metric-icon progress-icon">
                        <i class="fas fa-car-side"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">Retirados</div>
                        <div class="metric-description">Em uso</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.retreat || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status progress-status">
                        <i class="fas fa-circle"></i>
                        Em andamento
                    </span>
                </div>
            </div>

            <!-- Card Devolvidos -->
            <div class="metric-card completed-card" @click="$emit('card-clicked', 'devolvido')">
                <div class="metric-header">
                    <div class="metric-icon completed-icon">
                        <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">Devolvidos</div>
                        <div class="metric-description">Finalizados</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.devolved || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status completed-status">
                        <i class="fas fa-circle"></i>
                        Concluído
                    </span>
                </div>
            </div>

            <!-- Card Pré-reservas -->
            <div class="metric-card prereserve-card" @click="$emit('card-clicked', 'pre_reserva')">
                <div class="metric-header">
                    <div class="metric-icon prereserve-icon">
                        <i class="fas fa-clock"></i>
                    </div>
                    <div class="metric-content">
                        <div class="metric-period">Pré-reservas</div>
                        <div class="metric-description">Futuras</div>
                    </div>
                </div>

                <div class="metric-value-container">
                    <div v-if="count.loaded" class="metric-value">
                        {{ values.preReserves || 0 }}
                    </div>
                    <div v-else class="metric-loading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </div>

                <div class="metric-footer">
                    <span class="metric-status prereserve-status">
                        <i class="fas fa-circle"></i>
                        Agendado
                    </span>
                </div>
            </div>
        </div>

        <!-- Resumo total opcional -->
        <div class="metrics-summary" v-if="showSummary && count.loaded">
            <div class="summary-card">
                <div class="summary-icon">
                    <i class="fas fa-cars"></i>
                </div>
                <div class="summary-content">
                    <div class="summary-value">{{ getTotalVehicles() }}</div>
                    <div class="summary-label">Total de Veículos</div>
                </div>
            </div>

            <div class="summary-card">
                <div class="summary-icon">
                    <i class="fas fa-percentage"></i>
                </div>
                <div class="summary-content">
                    <div class="summary-value">{{ getUtilizationRate() }}%</div>
                    <div class="summary-label">Taxa de Utilização</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    props: {
        count: { // count - objeto com status de carregamento
            type: Object,
            required: true
        },
        values: { // values - valores das métricas
            type: Object,
            required: true
        },
        showHeader: { // showHeader - exibe cabeçalho opcional
            type: Boolean,
            default: false
        },
        showSummary: { // showSummary - exibe resumo adicional
            type: Boolean,
            default: false
        }
    },

    methods: {
        getTotalVehicles() { // getTotalVehicles - calcula total de veículos
            const total = (this.values.available || 0) +
                (this.values.retreat || 0) +
                (this.values.devolved || 0) +
                (this.values.preReserves || 0);
            return total;
        },

        getUtilizationRate() { // getUtilizationRate - calcula taxa de utilização
            const total = this.getTotalVehicles();
            const inUse = (this.values.retreat || 0) + (this.values.reservationsToday || 0);

            if (total === 0) return 0;

            return Math.round((inUse / total) * 100);
        }
    },

    emits: ['card-clicked'] // Emite evento quando card é clicado
};
</script>

<style scoped>
/* Usando variáveis CSS para consistência */
:root {
    --primary-color: #f8981d;
    --primary-light: #fd7e14;
    --success-color: #28a745;
    --info-color: #FE8D18;
    --warning-color: #ffc107;
    --danger-color: #dc3545;
    --dark-color: #343a40;
    --purple-color: #8b00c7;
    --text-primary: #2c3e50;
    --text-secondary: #6c757d;
    --border-color: #e2e8f0;
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 15px rgba(0, 0, 0, 0.08);
    --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.metrics-dashboard {
    width: 100%;
}

/* Header opcional */
.metrics-header {
    text-align: center;
    margin-bottom: 2rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
    border-radius: 12px;
    color: white;
}

.metrics-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.metrics-subtitle {
    font-size: 1rem;
    opacity: 0.9;
}

/* Grid de métricas reutilizando padrão existente */
.metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 2rem;
}

/* Card base - estendendo padrão metric-card existente */
.metric-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: var(--shadow-md);
    border: none;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.metric-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    transition: all 0.3s ease;
}

.metric-card:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-lg);
}

/* Temas específicos para cada tipo de card */
.available-card::before { background: linear-gradient(90deg, var(--success-color), #20c997); }
.available-card:hover { box-shadow: 0 8px 30px rgba(40, 167, 69, 0.15); }

.today-card::before { background: linear-gradient(90deg, var(--info-color), #0056b3); }
.today-card:hover { box-shadow: 0 8px 30px rgba(0, 123, 255, 0.15); }

.pending-card::before { background: linear-gradient(90deg, var(--danger-color), #c82333); }
.pending-card:hover { box-shadow: 0 8px 30px rgba(220, 53, 69, 0.15); }

.progress-card::before { background: linear-gradient(90deg, var(--primary-color), var(--primary-light)); }
.progress-card:hover { box-shadow: 0 8px 30px rgba(248, 152, 29, 0.15); }

.completed-card::before { background: linear-gradient(90deg, var(--dark-color), #212529); }
.completed-card:hover { box-shadow: 0 8px 30px rgba(52, 58, 64, 0.15); }

.prereserve-card::before { background: linear-gradient(90deg, var(--purple-color), #6a0099); }
.prereserve-card:hover { box-shadow: 0 8px 30px rgba(139, 0, 199, 0.15); }

/* Header do card */
.metric-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
}

.metric-icon {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.5rem;
    margin-right: 1rem;
    flex-shrink: 0;
}

/* Ícones específicos */
.available-icon { background: linear-gradient(135deg, var(--success-color), #20c997); }
.today-icon { background: linear-gradient(135deg, var(--info-color), #0056b3); }
.pending-icon { background: linear-gradient(135deg, var(--danger-color), #c82333); }
.progress-icon { background: linear-gradient(135deg, var(--primary-color), var(--primary-light)); }
.completed-icon { background: linear-gradient(135deg, var(--dark-color), #212529); }
.prereserve-icon { background: linear-gradient(135deg, var(--purple-color), #6a0099); }

.metric-content {
    flex: 1;
}

.metric-period {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 2px;
}

.metric-description {
    font-size: 0.875rem;
    color: var(--text-secondary);
    opacity: 0.8;
}

/* Valor da métrica */
.metric-value-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.metric-value {
    font-size: 2.5rem;
    font-weight: 800;
    color: var(--text-primary);
    text-align: center;
    line-height: 1;
}

.metric-loading {
    font-size: 1.5rem;
    color: var(--primary-color);
    text-align: center;
}

/* Footer do card */
.metric-footer {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}

.metric-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Status específicos */
.available-status {
    background-color: rgba(40, 167, 69, 0.1);
    color: var(--success-color);
}

.today-status {
    background-color: rgba(0, 123, 255, 0.1);
    color: var(--info-color);
}

.pending-status {
    background-color: rgba(220, 53, 69, 0.1);
    color: var(--danger-color);
}

.ok-status {
    background-color: rgba(40, 167, 69, 0.1);
    color: var(--success-color);
}

.progress-status {
    background-color: rgba(248, 152, 29, 0.1);
    color: var(--primary-color);
}

.completed-status {
    background-color: rgba(52, 58, 64, 0.1);
    color: var(--dark-color);
}

.prereserve-status {
    background-color: rgba(139, 0, 199, 0.1);
    color: var(--purple-color);
}

/* Resumo adicional */
.metrics-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 12px;
}

.summary-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: var(--shadow-sm);
    display: flex;
    align-items: center;
    gap: 15px;
    border-left: 4px solid var(--primary-color);
}

.summary-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
}

.summary-content {
    flex: 1;
}

.summary-value {
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--text-primary);
    line-height: 1;
    margin-bottom: 4px;
}

.summary-label {
    font-size: 0.75rem;
    color: var(--text-secondary);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Responsividade */
@media (max-width: 1200px) {
    .metrics-grid {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 15px;
    }
}

@media (max-width: 768px) {
    .metrics-grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 10px;
    }

    .metric-card {
        padding: 1rem;
        height: 160px;
    }

    .metric-value {
        font-size: 2rem;
    }

    .metric-icon {
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
    }

    .metrics-header {
        padding: 1rem;
    }

    .metrics-title {
        font-size: 1.25rem;
    }
}

@media (max-width: 576px) {
    .metrics-grid {
        grid-template-columns: 1fr;
    }

    .metric-header {
        flex-direction: column;
        text-align: center;
        gap: 10px;
    }

    .metric-icon {
        margin-right: 0;
    }

    .summary-card {
        flex-direction: column;
        text-align: center;
        gap: 10px;
    }
}

/* Animações de entrada */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.metric-card {
    animation: fadeInUp 0.6s ease-out;
    animation-fill-mode: both;
}

.metric-card:nth-child(1) { animation-delay: 0.1s; }
.metric-card:nth-child(2) { animation-delay: 0.2s; }
.metric-card:nth-child(3) { animation-delay: 0.3s; }
.metric-card:nth-child(4) { animation-delay: 0.4s; }
.metric-card:nth-child(5) { animation-delay: 0.5s; }
.metric-card:nth-child(6) { animation-delay: 0.6s; }
</style>



// WEBPACK FOOTER //
// src/components/Report/CardsTotal.vue